<template>
  <el-container>
    <el-header>
      <head_page :head_page_type=false ref="head_page"></head_page>
    </el-header>

    <el-main style="margin-top: 15px;">
      <head_menu :has-back=true @go-back-click="goBack">
        <template #title>
          <div style="text-align:center;background-color: #F0F0EE;color:#53ADBC;padding:5px;font-size: 20px;">
            {{chosen_city}}
          </div>
        </template>
        <template #button-group-right>
          <el-upload style="display: inline" :action="backend_url + '/upload_inventory/?chosen_city='+ chosen_city +'&user='+ user_name"
              accept=".xlsx" :on-success="uploadSuccess" :on-error="uploadError" :on-progress="uploadProgress"
              :show-file-list="false">
            <el-button style="text-align: center;">
                    {{$t('message.Upload_inventory')}}
            </el-button>
          </el-upload>
        </template>
      </head_menu>
      <div style="margin-top: 10px">
        <el-table :data="audits" style="width: 100%; margin-top: 10px"
          :header-cell-style="rowClass"
          @sort-change="handleAuditSortChange"
          tooltip-effect="light"
          >
          <el-table-column :label="$t('message.Status')" prop="status" align="center" min-width="90" width="90">
            <template slot-scope="scope">
              <md-close-circle-outline-icon v-if="scope.row.status == 'error'" w="20px" h="20px" style="color: red" />
              <md-checkmark-circle-outline-icon v-if="scope.row.status == 'success'" w="20px" h="20px" style="color: green" />
              <md-refresh-icon v-if="scope.row.status == 'pending'" w="20px" h="20px" style="color: rgb(79, 142, 247)" animate="rotate" />
            </template>
            <template slot-scope="scope" slot="header">
              <span :class="{ 'highlight': statusKeywordHighlight }">{{$t('message.Status')}}</span>
              <span class="el-table__column-filter-trigger"></span>
              <el-popover placement="bottom" trigger="click" transition="el-zoom-in-top" visible-arrow=false
                style="padding: 0; min-width: 50px" v-model="statusKeywordVisible">
                <div class="audit-table-filter">
                  <div class="audit-table-filter__content">
                    <li @click="statusFilterHandler('all')">{{$t('message.All')}}</li>
                    <li @click="statusFilterHandler('success')"><md-checkmark-circle-outline-icon w="20px" h="20px" style="color: green"/></li>
                    <li @click="statusFilterHandler('error')"><md-close-circle-outline-icon w="20px" h="20px" style="color: red" /></li>
                    <!--<li @click="statusFilterHandler('pending')"><md-refresh-icon w="20px" h="20px" style="color: rgb(79, 142, 247)" animate="rotate" /></li>-->
                  </div>
                </div>
                <span :class="{ 'highlight': statusKeywordHighlight }"  style="cursor: pointer; margin-left: 10px;" slot="reference"><i class="el-icon-search" style="transform: scale(0.75);"></i></span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.Start_date')" prop="start_date" min-width="80" width="160" sortable="custom">
            <template slot-scope="scope">
              <span>
                {{scope.row.start_date.split(".")[0]}}
              </span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.End_date')" prop="end_date" min-width="80" width="160" sortable="custom">
            <template slot-scope="scope">
              <span>
                {{scope.row.start_date.split(".")[0]}}
              </span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.Message')" prop="message" min-width="200">
          </el-table-column>
          <el-table-column :label="$t('message.User_name')" prop="user_name" min-width="80" width="160">
            <template slot-scope="scope" slot="header">
              <span :class="{ 'highlight': 'userArrayHighlight' }">{{$t('message.User_name')}}</span>
              <span class="el-table__column-filter-trigger"></span>
              <el-popover placement="bottom" trigger="click" transition="el-zoom-in-top" visible-arrow=false
                style="padding: 0;" v-model="userArrayVisible">
                <div class="audit-table-filter">
                  <div class="audit-table-filter__content">
                    <el-checkbox v-if="userList.length > 0" :indeterminate="userIndeterminate" v-model="userCheckAll" @change="userCheckAllHandler">{{$t('message.All')}}</el-checkbox>                        
                    <el-checkbox-group v-model="userArray" style="margin-top: 5px;" @change="userCheckHander">
                      <el-checkbox v-for="user in userList" :label="user" :key="user">{{user}} </el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div class="audit-table-filter__bottom">
                    <button @click="userFilterHandler" 
                      :class="{ 'is-disabled': userArray.length === 0 }"
                      :disabled="userArray.length === 0" >{{$t('message.Filter')}}</button>
                    <button @click="userResetHandler">{{$t('message.Reset')}}</button>
                  </div>
                </div>
                <span :class="{ 'highlight': userArrayHighlight }"  style="cursor: pointer; margin-left: 10px;" slot="reference"><i class="el-icon-search" style="transform: scale(0.75);"></i></span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.City')" prop="city" min-width="80" width="120">
          </el-table-column>
          <el-table-column :label="$t('message.File_name')" prop="file_name" min-width="250">
            <template slot-scope="scope">
              <span>
                {{scope.row.file_name.split('/')[scope.row.file_name.split('/').length-1]}}
              </span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('message.Operation')" align="center" min-width="100" width="100">
            <template slot-scope="scope">
              <span>
                <el-button v-if="scope.row.file_exists" icon="el-icon-download" style="background: rgba(33, 150, 243); color: white" @click="downloadFile(scope.row.file_name)"></el-button>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize">
        </el-pagination>
      </div>
      <div class="card" style="margin-top: 20px">
      </div>
    </el-main>
  </el-container>
</template>

<script>
  import head_page from './components/head_page.vue';
  import head_menu from './components/head_menu.vue';
  import { Message } from 'element-ui';
  import axios from 'axios';
  import _global from './components/global.vue';
  export default {
    name: 'inventory_history',
    data() {
      return {
        backend_url: _global.serverSrc,
        user: "",
        user_name: "",
        loading: true,
        chosen_city: this.$route.query.chosen_city,
        audits: [],
        userList: [],
        currentPage: 1,
        pageSize: 10,
        totalSize: 0,
        sortProps: {
          column: {},
          order: null,
          prop: "",
        },
        statusKeyword: "all",
        statusKeywordHighlight: false,
        statusKeywordVisible: false,
        userArray: [],
        userArrayHighlight: false,
        userArrayVisible: false,
        userIndeterminate: false,
        userCheckAll: false,
      }
    },
    computed: {
    },
    components: {
      head_page,
      head_menu
    },
    created() {
      if (JSON.parse(sessionStorage.getItem('User')) != null) {
        const name_arr = JSON.parse(sessionStorage.getItem('User')).split('@')[0].split('.')
        this.user = name_arr[0].toUpperCase();
        this.user_name = name_arr[0].toUpperCase() + " " + name_arr[1].toUpperCase()
      }
    },
    mounted() {
      this.$refs.head_page.update_user_name();
      this.getAuditData();
    },
    methods: {
      goBack(){
        this.$router.back()
      },
      getAuditData() {
        this.loading = true
        let payload = {
          "email": JSON.parse(sessionStorage.getItem('User')),
          "chosen_city": this.chosen_city,
          "currentPage": this.currentPage,
          "pageSize": this.pageSize,
          "statusKeyword": this.statusKeyword,
          "userArray": this.userArray,
          "sortProps": this.sortProps,
        }
        let api_url = _global.serverSrc + '/audit_trail_list/';
        this.$axios.post(api_url, payload).then(response => {
          if (response.data) {
            this.audits = []
            this.loading = false
            this.audits = response.data.audit_trail_list
            this.totalSize = response.data.total_number
            this.userList = response.data.user_list
            if (this.audits[0] && this.audits[0].status == "pending") {
              setTimeout(()=> this.getAuditData(), 5000)
            }
            
          }
        })
        .catch(error=> {
          console.log(error)
        });
      },
      handleAuditSortChange(sortProps) {
        this.sortProps = sortProps
        this.getAuditData()
      },
      handleSizeChange(val) {
        this.currentPage = this.currentPage*this.pageSize/val + this.currentPage*this.pageSize%val==0 ? 0:1
        this.pageSize = val;
        this.getAuditData()
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getAuditData()
      },
      downloadFile(filename) {
        let api_url = _global.serverSrc + '/file_download/';
        let obj = {
          email: JSON.parse(sessionStorage.getItem('User')),
          filename: filename
        }
        this.$axios.post(api_url, obj, {responseType: 'blob'}).then(response => {
          let blob = new Blob([response.data], {
            type: 'application/vnd.ms-excel'
          })
          // 切割出文件名
          let fileName = response.headers['content-disposition'].split("filename=")[1];
          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(blob, fileName)
          } else {
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = fileName
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
        })
        .catch(error=> {
          console.log(error)
        });
      },
      statusFilterHandler(status) {
        this.statusKeywordVisible = false;
        this.statusKeywordHighlight = status != "all";
        this.currentPage = 1
        this.statusKeyword = status;
        this.getAuditData()
      },
      userCheckAllHandler(val) {
        this.userArray = val ? this.userList : [];
        this.userIndeterminate = false;
      },
      userCheckHander(value) {
        let checkedCount = value.length;
        this.userCheckAll = checkedCount === this.userList.length;
        this.userIndeterminate = checkedCount > 0 && checkedCount < this.userList.length;
      },
      userResetHandler() {
        this.userCheckAll = false
        this.userArray= [];
        this.userIndeterminate = false;
        this.userArrayVisible = false
        this.currentPage = 1
        this.userArrayHighlight = false;
        this.getAuditData()
      },
      userFilterHandler() {
        this.userArrayVisible = false;
        this.currentPage = 1
        this.userArrayHighlight = this.userList.length != this.userArray.length;
        this.getAuditData()
      },
      rowClass({ rowIndex, columnIndex }) {
        if (rowIndex === 0) {       
            return {background:'#254A6E',color:'white'}
        }
      },
      uploadSuccess(response, file, fileList) {
        Message.closeAll()
        if (Number.isInteger(response.file_check)) {
          Message({
            showClose: true,
            message: this.$t('message.Upload_Inventory_Success'),
            type: 'success'
          });
          this.getAuditData();
        }
        else {
          Message({
            showClose: true,
            message: this.$t('message.' + response.file_check),
            type: 'error',
            duration: 0,
          });
        }
      },
      uploadError(err, file, fileList) {
        Message.closeAll()
        Message({
          showClose: true,
          message: this.$t('message.Upload_Inventory_Error_Network'),
          type: 'error',
          duration: 0,
        });
      },
      uploadProgress(event, file, fileList){
        Message.closeAll()
        Message({
          showClose: true,
          message: this.$t('message.Upload_Inventory_Progress'),
          duration: 0,
        });
      },
    },
    destroyed() {
      Message.closeAll()
    }

  }
</script>

<style lang="scss">
  .el-popover {
    min-width: 80px;
  }
</style>

<style lang="scss" scoped>
  /deep/ .p-datatable .p-datatable-tbody > tr > td {
    //word-break: break-all;
    font-size: 13px;
  }

  /deep/ .p-datatable .p-datatable-thead > tr > th {
    font-size: 14px;
  }

  /deep/ .p-component {
    font-size: 13px;
  }

  /deep/ .p-filter-column {
    padding: 0.5rem 0.5rem !important;
  }

  /deep/ .p-inputtext {
    font-size: 12px;
    padding: 0.5rem 0.2rem;
    text-align: left;
  }

  /deep/ .pi {
    font-size: 12px;
  }

  /deep/ .p-dropdown-trigger {
    width: 20px;
  }

  .card {
    background: var(--surface-e);
    padding: 2rem;
    -webkit-box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);
    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    margin-bottom: 2rem;
  }

  span.highlight{
    color: #409EFF;
  }

  /deep/.el-table__column-filter-trigger i {
    font-weight: bold;
    font-size: 18px;
    color: BLUE;
  }
  
  .audit-table-filter {
    margin: -12px;

    .audit-table-filter__content{
      padding: 10px 10px 0 10px;

      .sub-title {
        margin: 5px;
        line-height: 19px;
        font-size: 14px;
      }
      
      .search-input {
        margin: 5px;
        -webkit-appearance: none;
        background-color: #FFFFFF;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        height: 40px;
        line-height: 40px;
        outline: none;
        padding: 0 15px;
        -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        width: 200px;
      }

      input::-webkit-input-placeholder {
        color: #DCDFE6;
      }

      .el-checkbox {
        display: block;
        margin: 0 0 10px 10px;

        .el-checkbox__label {
          margin: 0 5px;
        }
      }

      li {
        list-style: none;
        line-height: 36px;
        padding: 0 20px;
        margin: 0;
        font-size: 14px;
        color: #606266;
        cursor: pointer;
        outline: none;
        text-align: center;
      }
    }

    .audit-table-filter__bottom {
      border-top: 1px solid #EBEEF5;
      padding: 13px;

      button {
        background: transparent;
        border: none;
        color: #606266;
        cursor: pointer;
        font-size: 13px;
        padding: 0 3px;

        
      }

      button.is-disabled {
        color: #C0C4CC;
        cursor: not-allowed;
      }
    }    
  }
  /deep/.el-table__header-wrapper .cell {
    line-height: 34px;
  }
</style>